export default __webpack_public_path__ + "static/arrow-green-63b5093c7df7b7a653c2daae372114e4.png";